import _ from 'lodash-es';
import intl from 'react-intl-universal';
import Evisit from './Evisit';

export default class VisitHelper {
    static provider_name = (data) => {
        let use_format = data.use_format ? data.use_format : ["Title", "FirstName", "LastName", "Suffix"];
        if (data.hosts) {
            let ret = [];
            for (const host of data.hosts) {
                ret.push(VisitHelper.provider_name({
                    first_name: host.full_name ? host.full_name : "",
                    last_name: null,
                    title: host.title ? host.title : "",
                    suffix: host.suffix ? host.suffix : "",
                    use_format: use_format
                }));
            }
            return ret.join('; ');
        }
        if (data.provider) {
            return VisitHelper.provider_name(data.provider);
        }

        let result = '', val = '';
        for (const format of use_format) {
            switch (format) {
                case 'Title':
                    // null and undefined would cast to "null" and "undefined" strings
                    if (data.title !== null && typeof data.title !== 'undefined') {
                        val = (String(data.title) || '').trim();
                        if (val) result += (result ? ' ' : '') + val;
                    }
                    break;
                case 'FirstName':
                    if (data.first_name !== null && typeof data.first_name !== 'undefined') {
                        val = (String(data.first_name) || '').trim();
                        if (val) result += (result ? ' ' : '') + val;
                    }
                    break;
                case 'LastName':
                    if (data.last_name !== null && typeof data.last_name !== 'undefined') {
                        val = (String(data.last_name) || '').trim();
                        if (val) result += (result ? ' ' : '') + val;
                    }
                    break;
                case 'Suffix':
                    if (data.suffix !== null && typeof data.suffix !== 'undefined') {
                        val = (String(data.suffix) || '').trim();
                        if (val) result += (result ? ', ' : '') + val;
                    }
                    break;
                default:
                    result += format;
            }
        }
        return result;
    };

    static max_wait_time = () => {
        let maxWaitTime = Evisit.c('Account.visit_options.time.max_wait_time', Evisit.c('Settings.config.data.visit.time.max_wait_time'));
        let lateStartBlackoutMin = Evisit.c('Account.visit_options.time.late_start_blackout_min', Evisit.c('Visit.LateStartBlackoutMin'));
        let lateStartBlackoutSec = lateStartBlackoutMin * 60;
        if (maxWaitTime > lateStartBlackoutSec && lateStartBlackoutSec > 0) {
            maxWaitTime = lateStartBlackoutSec;
        }
        return maxWaitTime;
    };

    static is_group_visit = (visit) => {
        return VisitHelper._is_class_visit(visit);
    }

    static _is_class_visit = (visit) => {
        if (!visit) return false;
        if (visit.VisitData) {
            visit = visit.VisitData;
        } else if (visit.Visit) {
            visit = visit.Visit;
        }
        return _.get(visit, 'class_id') || _.get(visit, 'group_id') ? true : false;
    };

    static is_class_visit = (visit) => {
        return VisitHelper._is_class_visit(visit) && !_.get(visit, 'group_id');
    };

    static type = (visit) => {
        let group = VisitHelper.is_group_visit(visit);
        let subType = _.get(visit, 'subtype', _.get(visit, 'sub_type', _.get(visit, 'subType', window.CONST.VISIT.SUBTYPE.VIDEO)));
        let is_class = VisitHelper.is_class_visit(visit);

        subType = subType || window.CONST.VISIT.SUBTYPE.VIDEO;
        let s = intl.get("video").d('Video');
        if (subType === window.CONST.VISIT.SUBTYPE.INPERSON) s = intl.get("in_person").d('In Person');
        if (subType === window.CONST.VISIT.SUBTYPE.ECONSULT) s = intl.get("e_consult").d('E-Consult');
        if (subType === window.CONST.VISIT.SUBTYPE.PHONE) s = intl.get("phone").d('Phone');
        if (group) {
            s += '<span class="badge badge-danger pull-right">' + intl.get("group").d('Group') + '</span>';
        } else if (is_class) {
            s += '<span class="badge badge-success pull-right">' + intl.get("class").d('Class') + '</span>';
        }
        return s;
    }

    static check_type_of = (value) => {
        return Object.prototype.toString.call(value).slice(8, -1)
    }

    static is_RTL_layout = () => {
        // A list of right-to-left languages
        const RTLLanguages = ['ara', 'ar'];
        return RTLLanguages.includes(_.get(window, "CONFIG.Language"));
    }
}
